import React from 'react';
import PropTypes from 'prop-types';
import { Cushion, MaxWidth } from '@pitchero/react-ui';
import { FIXTURES_PROP_TYPE } from '../../../lib/prop-types/fixture';
import PROFILES_PROP_TYPES from '../../../lib/prop-types/profile';
import { SEASONS_PROP_TYPES } from '../../../lib/prop-types/season';
import TopBannerVideoPlayerSwitch from '../../adverts/top-banner-video-player-switch';
import RosBottomBanner from '../../adverts/ros-bottom-banner';
import NativeShelf from '../../native-adverts/shelf';
import ProfileHeader from './header';
import ProfileHeaderLoading from './header-loading';
import ProfileFixtures from './fixtures';
import RelatedProfiles from './related';
import CricketStats from './cricket-stats';

const Profile = ({
  club,
  fixtures,
  isLoading,
  isLoadingSquad,
  teamId,
  onChangeSeason,
  profile,
  profileType,
  relatedProfiles,
  seasonId,
  seasons,
  stats,
}) => {
  const { advertisingTier, sportId } = club;
  return (
    <MaxWidth component="div" maxWidth={1366} center>
      <Cushion bottom="medium">
        <TopBannerVideoPlayerSwitch
          advertisingTier={advertisingTier}
          sportId={sportId}
          pageType="team.squad.player"
        />
      </Cushion>
      {profile ? (
        <ProfileHeader
          {...profile}
          isLoading={isLoading}
          onChangeSeason={onChangeSeason}
          profileType={profileType}
          seasonId={seasonId}
          seasons={seasons}
          stats={stats}
          teamId={teamId}
        />
      ) : (
        <ProfileHeaderLoading profileType={profileType} />
      )}
      <CricketStats stats={stats} />
      <Cushion bottom="large">
        <RosBottomBanner />
      </Cushion>
      <ProfileFixtures fixtures={fixtures} isLoading={isLoading} teamId={teamId} />
      <RelatedProfiles
        isLoading={isLoadingSquad}
        profiles={relatedProfiles}
        profileType={profileType}
        seasonId={seasonId}
        teamId={teamId}
      />
      <NativeShelf paddingProps={{ bottom: 'medium' }} />
    </MaxWidth>
  );
};

Profile.defaultProps = {
  profile: null,
  seasonId: null,
  stats: null,
};

Profile.propTypes = {
  club: PropTypes.shape({
    advertisingTier: PropTypes.number.isRequired,
    sportId: PropTypes.number.isRequired,
  }).isRequired,
  fixtures: FIXTURES_PROP_TYPE.isRequired,
  isLoading: PropTypes.bool.isRequired,
  isLoadingSquad: PropTypes.bool.isRequired,
  onChangeSeason: PropTypes.func.isRequired,
  profile: PropTypes.shape(),
  profileType: PropTypes.oneOf(['player', 'coach']).isRequired,
  relatedProfiles: PROFILES_PROP_TYPES.isRequired,
  seasonId: PropTypes.number,
  seasons: SEASONS_PROP_TYPES.isRequired,
  stats: PropTypes.shape(),
  teamId: PropTypes.number.isRequired,
};

export default Profile;
